<template>
    <div>
        <b-container>
            <b-card class="bg-template shadow mt-4 h-100">
                <b-row>
                    <b-col align-self="center" cols="auto">
                        <figure class="avatar avatar-60">
                            <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                                 :alt="(user.name + ' ' + user.lname).replace(',', '')"
                                 :title="(user.name + ' ' + user.lname).replace(',', '')">
                        </figure>
                    </b-col>
                    <b-col align-self="center" class="pl-0">
                        <h5 class="mb-1">{{ (user.name + ' ' + user.lname).replace(',', '') }}</h5>
                        <p class="text-mute small">
                            <strong>ID: {{ user.id === null ? '' : (user.id).toString().padStart(5, 0) }}</strong>
                        </p>
                    </b-col>
                    <b-col align-self="center" cols="auto">
                        <b-button variant="light" class="btn-rounded-54 shadow text-default" v-b-modal.qr @click="getQR">
                            <i class="material-icons icon-circle-center">qr_code_2</i>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
        <b-container>
            <b-row>
                <b-col cols="12" class="px-0">
                    <b-list-group flush class="my-4">
                        <template v-for="item in items">
                            <b-list-group-item :to="'/profile/' + item.link">
                                <h6 class="text-dark mb-0 font-weight-normal">
                                    <i class="material-icons align-middle">{{ item.icon }}</i>
                                    <span class="align-middle"> {{ item.name }} </span>
                                    <i class="material-icons float-right">chevron_right</i>
                                </h6>
                            </b-list-group-item>
                        </template>
                        <b-list-group-item button @click="logout">
                            <h6 class="text-danger mb-0 font-weight-normal">
                                <i class="material-icons align-middle">power_settings_new</i>
                                <span class="align-middle"> Cerrar Sesión </span>
                                <i class="material-icons float-right">chevron_right</i>
                            </h6>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </b-container>

        <!-- Modal QR -->
        <b-modal
            id="qr"
            centered
            no-fade
            header-class="text-center"
            header-bg-variant="primary"
            header-text-variant="light"
            header-close-variant="light"
            footer-class="border-0"
            hide-footer
            body-class="text-center"
            title="Mi QR"
            tabindex="-1"
            role="dialog"
            aria-hidden="true">
            <b-row no-gutters class="justify-content-center">
                <b-col cols="12" v-show="user.id">
                    <vue-qrcode :value="qrImg" :scale="8" :margin="0" :version="3" />
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col cols="12" align-self="center">
                    <b-button
                        variant="light"
                        class="mt-3"
                        style="text-transform: none;"
                        v-clipboard:copy="qrImg"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                    >{{ qrImg }} <b-badge variant="light"><i class="material-icons">content_copy</i></b-badge>
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import VueQrcode from 'vue-qrcode';

export default {
    name: "Profile",
    props: [ 'user' ],
    components: { VueQrcode },
    data: () => ({
        qrImg: '',
        items: [
            { name: "Mis Datos", icon: "badge", link: "information" },
            { name: "Mi Cuenta", icon: "account_balance_wallet", link: "account" },
            { name: "Favoritos", icon: "star", link: "favorites" },
            { name: "Seguridad", icon: "lock", link: "security" },
            { name: "Soporte", icon: "support_agent", link: "support" },
            { name: "Ayuda", icon: "help", link: "help" }
        ]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'profilepage');
    },
    methods: {
        async logout() {
            await this.$store.dispatch("logout");
            this.$root.$bvToast.toast('Has cerrado sesion correctamente.', {
                title: 'Felicitaciones',
                headerClass: 'd-none',
                variant: 'info',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            await this.$router.push({name: "Login"});
        },
        getQR() {
            const md5 = require('md5');
            this.qrImg = md5((this.user.id).toString());
        },
        onCopy(e) {
            this.$root.$bvToast.toast('Se copió en el portapapeles.', {
                title: e.text,
                headerClass: 'd-none',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        },
        onError(e) {
            this.$root.$bvToast.toast('No se copió al portapapeles.', {
                title: 'Error',
                headerClass: 'd-none',
                variant: 'error',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            console.log(e);
        }
    }
}
</script>

<style scoped>

</style>
